/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { checkboxStyleDefault, createTheme, iconOverrides } from "ag-grid-community";
import { COLORS } from "../../utils/constants";

export const rowHeight = 51;
export const headerHeight = 38;

const icons = iconOverrides({
	type: "font",
	family: "icomoon",
	icons: {
		asc: "\uE907",
		desc: "\uE904"
	}
});

export const agGridTheme = createTheme()
	.withPart(icons)
	.withPart(checkboxStyleDefault)
	.withParams({
		accentColor: COLORS.GREEN_50,
		backgroundColor: "transparent",
		headerBackgroundColor: "transparent",
		rowHoverColor: COLORS.SMART_NAVY_100,
		rowHeight: rowHeight,
		headerHeight: headerHeight,
		borderRadius: 0,
		headerFontWeight: 700,
		headerRowBorder: { style: "solid", width: 1, color: COLORS.WHITE },
		rowBorder: { style: "solid", width: 1, color: COLORS.GREY_100 },
		foregroundColor: COLORS.WHITE,
		selectedRowBackgroundColor: COLORS.SMART_NAVY_100,
		spacing: 8,
		wrapperBorder: false,
		wrapperBorderRadius: 0,
		checkboxBorderRadius: 0,
		checkboxBorderWidth: 1,
		checkboxCheckedBackgroundColor: "transparent",
		checkboxCheckedBorderColor: COLORS.WHITE,
		checkboxCheckedShapeColor: COLORS.WHITE,
		checkboxIndeterminateBackgroundColor: "transparent",
		checkboxIndeterminateBorderColor: COLORS.WHITE,
		checkboxUncheckedBackgroundColor: "transparent",
		checkboxUncheckedBorderColor: COLORS.WHITE,
		focusShadow: false
	});
